import React, { useState } from 'react'
import { connect } from 'react-redux'
import { useTranslation } from 'react-i18next'

import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import Edit from '@material-ui/icons/Edit'

import ViewWineNoteDialog from './dialog/ViewWineNoteDialog'
import EditWineNoteDialog from './dialog/EditWineNoteDialog'

import { formatNumber } from 'libraries/utils'
import { updateMemberWine } from '../actions/asyncWines'

import activitynoteIcon from 'static/images/icons/activitynote-24.svg'

const WineStorageMember = props => {
    const { t } = useTranslation();
    const [viewNoteDialog, setViewNoteDialog] = useState(false)
    const [editNoteDialog, setEditNoteDialog] = useState(false)
    const { data, currencyList, cwWineId, volume,
        memberWineNoteMap,
    } = props

    const handleViewNoteDialog = () => {
        setViewNoteDialog(!viewNoteDialog)
    }

    const handleEditNoteDialog = () => {
        setViewNoteDialog(false)
        setEditNoteDialog(!editNoteDialog)
    }

    const onSaveNote = (cost, currency, note) => {
        setEditNoteDialog(false)
        props.updateMemberWine({
            memberWineId: data.memberWineId,
            quantity: data.quantity,
            cost,
            currency,
            note,
            cwWineId,
            volume,
        })
    }

    const note = memberWineNoteMap.get(`${data.memberWineId}`)

    return (
        <Grid container style={{ padding: '16px 20px' }}>
            <Grid item md={2}>
                <Typography variant="body2" style={{ color: '#9fa2a3' }}>
                    {t('into_storage_date')}
                </Typography>
                <Typography style={{ fontSize: '1.25rem', fontWeight: 500, marginBottom: '16px' }}>
                    {data.createdAt}
                </Typography>
                <div>
                    <img src={activitynoteIcon} style={{ float: 'left' }} alt="" />
                    <Typography
                        variant="body2"
                        style={{
                            color: '#9fa2a3',
                            height: '42px',
                            lineHeight: 1.5,
                            WebkitLineClamp: 2,
                            WebkitBoxOrient: 'vertical',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            wordBreak: 'break-word',
                        }}
                    >
                        {note}
                    </Typography>
                </div>
            </Grid>
            <Grid item md={10} style={{ paddingLeft: '12px' }}>
                <Grid container justify="space-between" style={{ marginBottom: '14px' }}>
                    <div className="display-flex">
                        <div style={{ marginRight: '35px' }}>
                            <Typography variant="body2" style={{ color: '#9fa2a3' }}>
                                {t('bottle_number')}
                            </Typography>
                            <Typography style={{ fontSize: '1.25rem' }}>
                                {data.quantity}
                            </Typography>
                        </div>
                        <div>
                            <Typography variant="body2" style={{ color: '#9fa2a3' }}>
                                {t('avg_cost')}
                            </Typography>
                            <Typography style={{ fontSize: '1.25rem' }}>
                                {formatNumber(data.unitCost)}
                            </Typography>
                        </div>
                    </div>
                    <Edit
                        color="primary"
                        className="pointer"
                        onClick={handleEditNoteDialog}
                    />
                </Grid>
                <Grid container>
                    {data.storageOrderItems.map(wine => (
                        <Grid key={wine.code} item xs={3} style={{
                            border: '1px solid rgba(232, 232, 232)',
                            lineHeight: '30px',
                            textAlign: 'center',
                            margin: '-1px 0 0 -1px',
                        }}>
                            {wine.code}
                        </Grid>
                    ))}
                </Grid>
            </Grid>
            <ViewWineNoteDialog
                open={viewNoteDialog}
                onClose={handleViewNoteDialog}
                onOpenEditModal={handleEditNoteDialog}
                data={data}
                note={note}
            />
            <EditWineNoteDialog
                open={editNoteDialog}
                onClose={handleEditNoteDialog}
                onSaveNote={onSaveNote}
                data={data}
                note={note}
                currencyList={currencyList}
            />
        </Grid>
    )
}

export default connect(
    state => ({
        currencyList: state.member.member.currencyList,
        memberWineNoteMap: state.wines.memberWineNoteMap,
    }),
    { updateMemberWine }
)(WineStorageMember)